import { useQuery } from '@tanstack/react-query';
import { PricingModelEnum } from '@pxtra-client-lib-legacy/gen';
import { apiClient } from '../../lib/util';
import { checkHasCompanyCustomBenefits } from '../../lib/util/pricingModel';

export const useListCustomBenefits = (
  companyId: string,
  pricingModel?: PricingModelEnum,
  options = {}
) => {
  return useQuery({
    queryKey: ['custom', companyId ?? 'MISSING_COMPANY_ID'],
    queryFn: () => {
      return apiClient.benefits.benefitsCustomList({
        company: companyId
      });
    },
    enabled: !!companyId && checkHasCompanyCustomBenefits(pricingModel),
    ...options
  });
};

export const useGetCustomBenefit = (id: string, options = {}) => {
  return useQuery({
    queryKey: ['custom', id],
    queryFn: () => {
      return apiClient.benefits.benefitsCustomRetrieve({
        id: id
      });
    },
    ...options
  });
};

export const useGetAvailableConstraints = (
  companyId: string,
  excludeCustomBenefitId?: string,
  options = {}
) => {
  return useQuery({
    queryKey: ['availableConstraints', companyId, excludeCustomBenefitId],
    queryFn: async () => {
      const result = await apiClient.benefits.benefitsCustomAvailableConstraintsRetrieve({
        company: companyId,
        exclude: excludeCustomBenefitId
      });
      return result.available_constraints;
    },
    ...options
  });
};
